module.exports = __webpack_public_path__ + "static/media/VisbyCF-Heavy.94dff166.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VisbyCF-Heavy.woff
// module id = 799
// module chunks = 0